module.exports = __webpack_public_path__ + "components/flag/static/square/ga-48b4818fa423d398e7eeb20f80f3164c.svg";